module.exports = __webpack_public_path__ + "static/media/VMIPO_HomescreenBanner.3cfd6f23.jpg";